import React from 'react'
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper/modules';
import 'swiper/css';
import default_pro from '../../Assets/Images/pro.png'
import { Link } from 'react-router-dom';
import API from '../../ApiService/ApiService';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
const RelatedProducts = ({ relatedProduct }) => {
  const api = new API();
  return (
    <RelatedSection>
      <h2>Related Products</h2>
      <Swiper
        spaceBetween={22}
        slidesPerView={3}
        navigation
        modules={[Navigation, Pagination, Scrollbar, Autoplay]}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        // pagination={{ clickable: true }}
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
        className="related_slider"
      >
        {
          relatedProduct?.map((e, i) => (
            <SwiperSlide key={i}>
              <Link to={`/product/${e?.slug}`} title={e?.name}><div className='related_items'>
                <div className='related_image'>
                  {/* <img src={default_pro} alt={e?.name} /> */}
                  {
                    e?.image?.slice(0, 1).map((e, i) => {
                      return (
                        <img src={e.image_path ? api.apiUrl + e.image_path : default_pro} alt={e?.name} key={i} />
                      )
                    })
                  }
                </div>
                <div className='related_content'>
                  <h4>{e?.name}</h4>
                </div>
              </div></Link>
            </SwiperSlide>
          ))
        }
      </Swiper>
    </RelatedSection>
  )
}

export default RelatedProducts;


const RelatedSection = styled.section`
display: inline-block;
width: 100%;
margin: 0 0 60px;
h2 {
  color: #2E2C2C;
    font-size: 27px;
    margin: 0 0 30px;
    font-family: "Helvetica";
    font-weight: 600;
}

.related_slider {
  padding: 0 1px;
}

.related_items {
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
}
.related_content {
  padding: 20px;
}
.related_content h4 {
  font-family: 'Helvetica';
  font-weight: 600;
  font-size: 18px;
  color: #C94142;
}
.related_items img {
  position: relative;
  z-index: 10;
}

.swiper-button-prev, .swiper-button-next {
  background: #C94142;
  border-radius: 5px;
  box-shadow: 0 0 10px rgb(0 0 0 / 30%);
  z-index: 100;
}
.swiper-button-prev:after, .swiper-button-next:after {
  font-size: 16px;
  font-weight: 600;
  color:#fff
}


`;